<template>
  <span>
    <strong class="mr-1" v-if="number">
      {{ numberWithCommas(number) }} {{ unit }}
    </strong>
    <strong v-else>0</strong>
  </span>
</template>

<script>
export default {
  name: "number-component",
  props: {
    number: { type: Number },
    unit: { type: String }
  },
  methods: {
    numberWithCommas(id) {
      if (id) {
        return id.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
    }
  }
};
</script>
